import axios from '@/axios'

export default {
	namespaced: true,

	state: {
		purchases: [],
	},

	actions: {
		fetchAll({ commit }, { providerId, ownerId, date, status, orderByName, page, perPage, ownerIds, usePagination }) {
			const params = { providerId, ownerId, date, status, orderByName, page, perPage, usePagination };
			const urlSearchParams = new URLSearchParams();
			Object.keys(params).forEach(key => {
				if (params[key] !== null && params[key] !== undefined) urlSearchParams.append(key, params[key]);
			});
			urlSearchParams.append('nonDeleted', true);

			if (Array.isArray(ownerIds)) {
				ownerIds.forEach(id => urlSearchParams.append('ownerIds', id));
			}

			return axios.get('/purchases', { params: urlSearchParams });
		},
		
		fetchById({ commit }, { id }) {
			return axios.get(`/purchases/${id}`);
		},

		create({ commit }, { date, providerId, ownerId, entryNo, weight, density, isSeed, items, administrationPrice, administrationAcceptance, farmerAcceptance, pepperColumns }) {
			return axios.post('/purchases', { date, providerId, ownerId, entryNo, weight, density, isSeed, items, administrationPrice, administrationAcceptance, farmerAcceptance, pepperColumns });
		},

		update({ commit }, { id, date, providerId, ownerId, entryNo, weight, density, isSeed, items, administrationPrice, administrationAcceptance, farmerAcceptance, pepperColumns }) {
			return axios.put(`/purchases/${id}`, { date, providerId, ownerId, entryNo, weight, density, isSeed, items, administrationPrice, administrationAcceptance, farmerAcceptance, pepperColumns });
		},

		updateState({ commit }, { id, administrationPrice, administrationAcceptance, farmerAcceptance }) {
			return axios.put(`/purchases/${id}/status`, { administrationPrice, administrationAcceptance, farmerAcceptance })
		},
		
		delete({ commit }, { id }) {
			return axios.delete(`/purchases/${id}`)
		},

		getWeightedAveragesByProvider ({ commit }, { providerId }) {
			return axios.get(`/Purchases/WeightedAveragesByProvider/${providerId}`).then(data => {
				return data
			})
		}
	},
}